/** Driver100 / Telimani100 — Play Store privacy & delete-account copy. */
export const PLATFORM_BRAND = 'Driver100 / Telimani100';

export const PLATFORM_SUPPORT_EMAIL = 'nplus4all@gmail.com';

export const PLATFORM_APPS =
  'Driver100 User, Driver100 Partner, Driver100 Provider, Driver100 Vendor, Telimani100 User, Telimani100 Partner, Telimani100 Provider, and Telimani100 Vendor';

export const PLATFORM_PRIVACY_SUBTITLE =
  'This Privacy Policy applies to everyone who uses Driver100 and Telimani100 mobile apps and related services — customers, drivers, delivery partners, service providers, and vendors.';

export const PLATFORM_PRIVACY_MARKDOWN = `
# Driver100 / Telimani100 - Privacy Policy

**Last updated:** 2026-10-18

${PLATFORM_PRIVACY_SUBTITLE}

## 1. Who we are
We operate the Driver100 and Telimani100 apps, which include ${PLATFORM_APPS}. These apps provide transport, delivery, on-demand services, and related features. By using any of these apps you agree to this policy.

## 2. Information we collect
- Account details: name, phone number, email, profile photo (if provided)
- Location: when you use maps, rides, delivery, or on-demand booking (with permission)
- Usage & device: app version, device type, IP address, crash/log data for security and reliability
- Transactions: trips, orders, bookings, payments, and support history needed to run the service

## 3. How we use information
- To create and manage your Driver100 / Telimani100 account
- To provide rides, deliveries, bookings, and support
- To match customers with drivers, partners, or providers
- To process payments and prevent fraud
- To improve safety, performance, and product quality
- To meet legal and regulatory requirements

## 4. Sharing of information
We share information only when needed:
- With drivers, merchants, or providers to complete your request
- With payment processors and infrastructure partners
- When required by law, regulators, or valid legal process

We do not sell your personal information.

## 5. Data retention
We keep account and transaction data while your account is active, and longer where required for law, tax, disputes, or safety. After you delete your account we remove or anonymize personal data that is no longer needed.

## 6. Your choices
- Update profile details in the app
- Control location and notification permissions on your device
- Request account deletion via our Delete Account page

## 7. Children's privacy
Driver100 and Telimani100 are not directed to children under the age required by local law. We do not knowingly collect personal data from children.

## 8. Security
We use reasonable technical and organizational measures to protect your data. No method of transmission or storage is 100% secure.

## 9. Changes
We may update this policy from time to time. The "Last updated" date at the top will change when we do. Continued use of the app means you accept the updated policy.

## 10. Contact
For privacy questions or requests, contact us at ${PLATFORM_SUPPORT_EMAIL} or use in-app support.
`.trim();

export const PLATFORM_DELETE_HELP =
  `Enter the phone number or email you used to sign up in the app. We will send a one-time verification code. After you confirm, we permanently close matching Driver100 / Telimani100 accounts (${PLATFORM_APPS}). You will lose access to the apps linked to that phone or email. Some anonymized trip or order records may be kept where required by law or for safety.`;

export const PLATFORM_DELETE_APPLIES_TO = `Applies to: ${PLATFORM_APPS}`;
